import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const problems = [{
  name: 'Accuracy',
  tone: INK.blue,
  line: 'Non-deterministic outputs and inconsistent research.',
  proofValue: '7.2 · 5.8 · 8.4',
  proofLabel: 'Same question, three different scores'
}, {
  name: 'Privacy',
  tone: INK.violet,
  line: 'Proprietary firm and company data needs controlled enterprise infrastructure.',
  proofValue: 'Data room → prompt',
  proofLabel: 'Confidential context pasted into general tools'
}, {
  name: 'Cost',
  tone: INK.gold,
  line: 'Frontier models are inefficient for repetitive institutional workflows.',
  proofValue: '1 model · every task',
  proofLabel: 'Frontier pricing on classification and tagging'
}];
export function ProblemSlide() {
  return <Slide data-id="element-395" data-mp="1rj99t6cxq24">
      <Eyebrow data-id="element-396" data-mp="1rt2dpmp8dc1">The problem</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[74%]" data-id="element-397" data-mp="30g9sa267rz2s">
        Private-market teams are adopting AI. General-purpose models weren&apos;t
        designed for institutional diligence.
      </Title>

      <div className="mt-auto grid grid-cols-3 gap-[2.4cqw]" data-id="element-398" data-mp="39fmzspas2dkv">
        {problems.map((p, i) => <Reveal key={p.name} delay={0.06 * i} className="flex flex-col border-t border-white/12 pt-[3cqh]" data-id="element-399" data-mp="3efsp3ytkrnzs" data-mpi={i}>
            <div className="flex items-baseline justify-between" data-id="element-400" data-mp="3jdayfqbi858b">
              <span className="text-[0.8cqw] tracking-[0.24em] text-white/35" data-id="element-401" data-mp="3nfxr1tg01u6k">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="h-px w-[3cqw]" style={{
            background: p.tone
          }} aria-hidden data-id="element-402" data-mp="3s7z59kwq9uz8" />
            </div>
            <p className="mt-[2cqh] text-[4.2cqw] leading-none" style={{
          ...SERIF,
          color: p.tone
        }} data-id="element-403" data-mp="zuwe65dc3yb">
              {p.name}
            </p>
            <p className="mt-[2.4cqh] max-w-[92%] text-[1.25cqw] leading-snug text-[#E3E8F1]" data-id="element-404" data-mp="ayk9llmbl088">
              {p.line}
            </p>
            <div className="mt-[5cqh] border border-white/10 bg-white/[0.025] px-[1.4cqw] py-[2.4cqh]" data-id="element-405" data-mp="3hguf4k9b5xgr">
              <p className="text-[1.5cqw] leading-none text-[#C3CBD9]" style={SERIF} data-id="element-406" data-mp="3ci11mru0u6gl">
                {p.proofValue}
              </p>
              <div className="mt-[1.2cqh]" data-id="element-407" data-mp="3r7p4hxhupd6f">
                <Label data-id="element-408" data-mp="3mem6nd61jhkf">{p.proofLabel}</Label>
              </div>
            </div>
          </Reveal>)}
      </div>
    </Slide>;
}